import { isMobile, isSafari } from 'mobile-device-detect'

import defaultImage from '@/assets/images/no-avt.png'
import { _ } from 'core-js'
import DOMPurify from 'dompurify'
import firebase from 'firebase/app'
import heic2any from 'heic2any'
import { marked } from 'marked'
import moment from 'moment/moment'
import slugify from 'slugify'
import Vue from 'vue'
import { floor10 } from './decimalAdjustment'
import rolesPermissions from './rolesPermissions'

/* eslint-disable no-useless-escape */
/* eslint eqeqeq: ["error", "smart"] */

DOMPurify.addHook('afterSanitizeElements', node => {
  if (node.nodeName === 'P' && !node.textContent.trim()) node.remove()
})

const mapLang = [
  { id: 1, code: 'vi' },
  { id: 2, code: 'en' },
  { id: 3, code: 'fr' },
  { id: 4, code: 'jp' }
]
const appUtils = {
  gg: function () {
    return 3
  },
  numberFormat (number, currencyUnit) {
    let data = number
      ?.toString()
      .replace(/\D/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    // let data = number.toLocaleString(undefined, { minimumFractionDigits: 0 });
    if (currencyUnit) {
      data += ` ${currencyUnit}`
    }
    return data
  },

  padStart (n, width, z) {
    z = z || '0'
    n = n + ''
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
  },
  setLocalToken (token) {
    Vue.prototype.$jwtToken = token
    return localStorage.setItem('jwt_token', token)
  },
  // clinic id
  setClinicId (id) {
    Vue.prototype.$clinicId = parseInt(id)
    return localStorage.setItem('global_wp_id', id)
  },
  removeClinicId () {
    Vue.prototype.$clinicId = null
    localStorage.removeItem('global_wp_id')
  },
  getClinicId () {
    return localStorage.getItem('global_wp_id')
  },

  // clinic
  getDoctorClinic: () => (localStorage.getItem('global_clinic') ? JSON.parse(localStorage.getItem('global_clinic')) : null),
  removeDoctorClinic () {
    this.removeClinicId()
    Vue.prototype.$globalClinic = null
    localStorage.removeItem('global_clinic')
  },
  setDoctorClinic (clinic) {
    this.setClinicId(clinic?.id)
    Vue.prototype.$globalClinic = clinic
    this.removeGlobalOrg()
    localStorage.setItem('global_clinic', JSON.stringify(clinic))
  },
  // org
  getOrgId () {
    const userInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null

    if (!userInfo) return null

    return userInfo.org_id
  },
  getGlobalOrg: () => (localStorage.getItem('global_org') ? JSON.parse(localStorage.getItem('global_org')) : null),
  removeGlobalOrg () {
    Vue.prototype.$globalOrg = null
    localStorage.removeItem('global_org')
  },
  setGlobalOrg (org) {
    Vue.prototype.$globalOrg = org
    this.removeClinicId()
    this.removeDoctorClinic()
    localStorage.setItem('global_org', JSON.stringify(org))
  },
  getAppMode: () => Number(localStorage.getItem('app_mode')),
  setAppMode: mode => {
    Vue.prototype.$appMode = mode
    localStorage.setItem('app_mode', mode)
  },

  // !org
  getLocalToken () {
    return localStorage.getItem('jwt_token')
  },
  removeLocalToken () {
    localStorage.removeItem('jwt_token')
  },
  getLocalUser: () => (localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null),
  removeLocalUser () {
    Vue.prototype.$user = null
    localStorage.removeItem('user')
  },
  setLocalUser: user => {
    Vue.prototype.$user = user
    localStorage.setItem('user', JSON.stringify(user))
  },
  //
  setFeatureList (data) {
    Vue.prototype.$featureList = data
    return localStorage.setItem('feature_list', JSON.stringify(data))
  },
  removeFeatureList () {
    Vue.prototype.$featureList = null
    localStorage.removeItem('feature_list')
  },
  getFeatureList () {
    return JSON.parse(localStorage.getItem('feature_list'))
  },
  setFeatureWsList (data) {
    Vue.prototype.$featureWsList = data
    return localStorage.setItem('feature_ws_list', JSON.stringify(data))
  },
  removeFeatureWsList () {
    Vue.prototype.$featureWsList = null
    localStorage.removeItem('feature_ws_list')
  },
  getFeatureWsList () {
    return JSON.parse(localStorage.getItem('feature_ws_list'))
  },
  setFeatureOrgList (data) {
    Vue.prototype.$featureOrgList = data
    return localStorage.setItem('feature_org_list', JSON.stringify(data))
  },
  removeFeatureOrgList () {
    Vue.prototype.$featureOrgList = null
    localStorage.removeItem('feature_org_list')
  },
  getFeatureOrgList () {
    return JSON.parse(localStorage.getItem('feature_org_list'))
  },
  //
  isAdmin () {
    const user = this.getLocalUser()
    if (user) {
      return user?.roles?.includes('admin')
    }

    return false
  },
  isClinic () {
    const user = this.getLocalUser()
    if (user) {
      return user?.roles?.includes('clinic')
    }

    return false
  },
  isDoctor () {
    const user = this.getLocalUser()
    if (user) {
      return user?.roles?.includes('doctor')
    }

    return false
  },

  randomStr (length, isNumber) {
    var result = ''
    var characters = isNumber ? '0123456789' : 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  },
  /**
   * @param canvas
   * @param photo
   * @param width
   * @returns {*}
   */
  onResizeImage (canvas, photo, width = 300) {
    let ctx = canvas.getContext('2d')

    canvas.width = width
    canvas.height = width * (photo.height / photo.width)
    ctx.drawImage(photo, 0, 0, canvas.width, canvas.height)
    const base64Image = canvas.toDataURL()
    if (base64Image) {
      let resizePhoto = new Image()
      resizePhoto.src = base64Image

      return resizePhoto
    }

    return false
  },
  getImageURL (path) {
    if (!path) return ''
    if (path.includes('https')) return path
    return process.env.VUE_APP_BASE_IMAGE_URL + 'storage/' + path
  },
  getDocumentURL (path) {
    return process.env.VUE_APP_BASE_IMAGE_URL + 'storage/' + path
  },
  setFirebaseAccessToken: token => localStorage.setItem('firebase_access_token', token),
  getFirebaseAccessToken: () => (localStorage.getItem('firebase_access_token') ? localStorage.getItem(' firebase_access_token') : null),
  removeFirebaseAccessToken () {
    localStorage.removeItem('firebase_access_token')
  },
  checkShow () {
    var node = process.env.NODE_ENV
    if (node === 'development') {
      return true
    } else {
      return false
    }
  },
  setLocalLang (lang) {
    return localStorage.setItem('lang', lang || 'vi')
  },
  getLocalLang () {
    return localStorage.getItem('lang')
  },
  removeLocalLang () {
    return localStorage.setItem('lang', 'vi')
  },
  removeVietnameseTones (str) {
    if (!str) return ''
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
    str = str.replace(/đ/g, 'd')
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A')
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E')
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I')
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O')
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U')
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y')
    str = str.replace(/Đ/g, 'D')
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '') // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, '') // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau
    str = str.replace(/ + /g, ' ')
    str = str.trim()
    // Remove punctuations
    // Bỏ dấu câu, kí tự đặc biệt
    // str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, ' ')
    return str
  },
  finishInfomation () {
    let user = Vue.prototype.$user
    return !!user?.name
  },
  getGender (gender) {
    return gender === 1 ? 'Nam' : gender === 2 ? 'Nữ' : 'Khác'
  },
  getFilename (fullPath) {
    if (!_.isString(fullPath)) return
    return fullPath.split('/').pop()
  },
  getLangCode (id) {
    if (!id || isNaN(id)) return
    const found = mapLang.find(l => l.id === parseInt(id))
    return found?.code
  },
  getLangId (l) {
    if (!l) return
    const found = mapLang.find(item => item.code === l)
    return found?.id
  },
  getNations () {
    return mapLang
  },
  base64: {
    decode: s => window.btoa(unescape(encodeURIComponent(s))),
    encode: b => decodeURIComponent(escape(window.atob(b)))
  },
  utf8ToBase64 (str) {
    const encodedStr = new TextEncoder()
    const data = encodedStr.encode(str)
    const binaryStr = String.fromCharCode.apply(null, data)
    return btoa(binaryStr)
  },
  base64ToUtf8 (b64) {
    const normalized = String(b64 || '')
      .replace(/^data:.*?;base64,/, '')
      .replace(/\s/g, '')
    if (!normalized) return ''

    const binaryStr = atob(normalized)
    const bytes = new Uint8Array(binaryStr.length)
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = binaryStr.charCodeAt(i)
    }
    const decoded = new TextDecoder()
    return decoded.decode(bytes)
  },
  convertString ({ value, length = 4 }) {
    let alias_char = ''
    for (let i = 0; i < length; i++) {
      alias_char += 'X'
    }
    return value ? `${value?.slice(0, value?.length - length - 4)}${length > 0 ? alias_char : ''}${length > 0 ? value?.slice(value?.length - 4, value.length) : ''}` : ''
  },
  templateHTMLPrint ({ bodyHTML, title = '', lang = 'vi', appendStyle = false }) {
    let domain = window.location.origin
    if (domain === 'http://localhost:8081') {
      domain = 'https://dev.hodo.app'
    }
    const styleCss = `
      <link rel="stylesheet" type="text/css" href="${domain}/assets/tabler/dist/css/tabler.min.css">
      <link rel="stylesheet" type="text/css" href="${domain}/assets/css/tailwindcss.css">
      <link rel="stylesheet" type="text/css" href="${domain}/assets/css/print.css">
      <link rel="stylesheet" type="text/css" href="${domain}/assets/css/print.module.css">
      <link rel="stylesheet" type="text/css" href="https://use.fontawesome.com/releases/v5.8.1/css/all.css">
    `
    const template = `<html lang="${lang}"><head><meta charset="UTF-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1"><title>${title}</title><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Tinos:ital,wght@0,400;0,700;1,400;1,700&display=swap" rel="stylesheet">${appendStyle ? styleCss : ''}<style>
    /* vietnamese */
    @font-face {
      font-family: "Times";
      font-weight: 700;
      src: url("${domain}/assets/font/tnr/bold.ttf");
    }
    @font-face {
      font-family: "Times";
      font-weight: 700;
      font-style: italic;
      src: url("${domain}/assets/font/tnr/bold-italic.ttf");
    }
    @font-face {
      font-family: "Times";
      font-weight: 400;
      src: url("${domain}/assets/font/tnr/regular.ttf");
    }
    @font-face {
      font-family: "Times";
      font-weight: 400;
      font-style: italic;
      src: url("${domain}/assets/font/tnr/regular-italic.ttf");
    }
    html, body {
      font-family: "Times New Roman", "Times", "Tinos", serif !important;
      font-size: 1.0625rem;
      line-height: 1.5rem;
      font-weight: 500;
      font-style: normal;
      letter-spacing: 0em;
      color: #000000 !important;
    }
    #wrapper {overflow-x: hidden;}@font-face {font-family: "Times";font-weight: 700;src: url("${domain}/assets/font/tnr/bold.ttf");}@font-face {font-family: "Times";font-weight: 700;font-style: italic;src: url("${domain}/assets/font/tnr/bold-italic.ttf");}@font-face {font-family: "Times";font-weight: 400;src: url("${domain}/assets/font/tnr/regular.ttf");}@font-face {font-family: "Times";font-weight: 400;font-style: italic;src: url("${domain}/assets/font/tnr/regular-italic.ttf");}@import url("https://fonts.googleapis.com/css2?family=Tinos:ital,wght@0,400;0,700;1,400;1,700&display=swap");#ElementToPrint, #ElementToPrint *:not([class*=" el-icon-"], [class^="el-icon-"]), #ElementToPrint p, #ElementToPrint span {font-family: "Times New Roman", "Times", "Tinos", serif !important;color: black;}#ElementToPrint {}#CareDetail, #CareDetail i, #CareDetail ul, #CareDetail li, #CareDetail p, #CareDetail strong, #phieuPhauThuatViewDetail, #phieuPhauThuatViewDetail p, #phieuPhauThuatViewDetail strong, #phieuPhauThuatViewDetail i, #PhieuGayMeViewDetail, #PhieuGayMeViewDetail p, #PhieuGayMeViewDetail strong, #PhieuGayMeViewDetail i, #PhieuChamSocViewDetail, #PhieuChamSocViewDetail p, #PhieuChamSocViewDetail strong, #PhieuChamSocViewDetail span {color: black;margin: 0;font-family: "Times New Roman", "Times", "Tinos", serif !important;}#CareDetail, #CareDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #phieuPhauThuatViewDetail, #phieuPhauThuatViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #PhieuGayMeViewDetail, #PhieuGayMeViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #PhieuChamSocViewDetail, #PhieuChamSocViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #TempPhieuChucNangSong, #TempPhieuChucNangSong *:not([class*=" el-icon-"], [class^="el-icon-"]) {color: black;font-family: "Times New Roman", "Times", "Tinos", serif !important;}#TemplatePrescription, #TemplatePrescription *:not([class*=" el-icon-"], [class^="el-icon-"]), #TemplatePrescription p, #TemplatePrescription div, #TemplatePrescription span, #MedicalRecordsViewDetail, #MedicalRecordsViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #MedicalRecordsViewDetail p, #MedicalRecordsViewDetail label, #MedicalRecordsViewDetail div, #MedicalRecordsViewDetail span, #MedicalRecordsViewDetail strong, #MedicalRecordsViewDetail i, #MedicalRecordsViewDetailPage1, #MedicalRecordsViewDetailPage1 *:not([class*=" el-icon-"], [class^="el-icon-"]), #MedicalRecordsViewDetailPage1 p, #MedicalRecordsViewDetailPage1 label, #MedicalRecordsViewDetailPage1 div, #MedicalRecordsViewDetailPage1 span, #MedicalRecordsViewDetailPage1 strong, #MedicalRecordsViewDetailPage1 i, #MedicalRecordsViewDetailPage2, #MedicalRecordsViewDetailPage2 *:not([class*=" el-icon-"], [class^="el-icon-"]), #MedicalRecordsViewDetailPage2 p, #MedicalRecordsViewDetailPage2 label, #MedicalRecordsViewDetailPage2 div, #MedicalRecordsViewDetailPage2 span, #MedicalRecordsViewDetailPage2 strong, #MedicalRecordsViewDetailPage2 i, #MedicalRecordsViewDetailPage3, #MedicalRecordsViewDetailPage3 *:not([class*=" el-icon-"], [class^="el-icon-"]), #MedicalRecordsViewDetailPage3 p, #MedicalRecordsViewDetailPage3 label, #MedicalRecordsViewDetailPage3 div, #MedicalRecordsViewDetailPage3 span, #MedicalRecordsViewDetailPage3 strong, #MedicalRecordsViewDetailPage3 i, #tmpPhieuGayMe, #tmpPhieuGayMe *:not([class*=" el-icon-"], [class^="el-icon-"]), #tmpPhieuGayMe p, #tmpPhieuGayMe div, #tmpPhieuGayMe span, #tmpPhieuGayMe p, #tmpPhieuGayMe label, #tmpPhieuGayMe div, #tmpPhieuGayMe span, #tmpPhieuGayMe strong, #tmpPhieuGayMe i, #modalPhieuGayMe, #modalPhieuGayMe *:not([class*=" el-icon-"], [class^="el-icon-"]), #modalPhieuGayMe p, #modalPhieuGayMe div, #modalPhieuGayMe span, #modalPhieuGayMe p, #modalPhieuGayMe label, #modalPhieuGayMe div, #modalPhieuGayMe span, #modalPhieuGayMe strong, #modalPhieuGayMe i, #TreatmentViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #TreatmentViewDetail div, #TreatSumsViewDetail div, #TreatmentViewDetail span, #TreatSumsViewDetail span, #CareDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #CareDetail div, #CareDetail span, #bienbantemp, #bienbantemp *:not([class*=" el-icon-"], [class^="el-icon-"]), #bienbantemp div, #bienbantemp span, #bienbantemp strong, #bienbantemp i, #meetConcludingTemp, #meetConcludingTemp *:not([class*=" el-icon-"], [class^="el-icon-"]), #meetConcludingTemp p, #meetConcludingTemp div, #meetConcludingTemp span, #meetConcludingTemp strong, #meetConcludingTemp i, #TTTQMTemp, #TTTQMTemp *:not([class*=" el-icon-"], [class^="el-icon-"]), #TTTQMTemp p, #TTTQMTemp div, #TTTQMTemp span, #TTTQMTemp strong, #TTTQMTemp i, #IndicationsPrinter, #IndicationsPrinter *:not([class*=" el-icon-"], [class^="el-icon-"]), #IndicationsPrinter div, #IndicationsPrinter span, #IndicationsPrinter i, #IndicationResultPrintTemplate, #IndicationResultPrintTemplate *:not([class*=" el-icon-"], [class^="el-icon-"]), #IndicationResultPrintTemplate p, #IndicationResultPrintTemplate div, #IndicationResultPrintTemplate b, #IndicationResultPrintTemplate i, #IndicationResultPrintTemplate h1, #IndicationResultPrintTemplate h2, #IndicationResultPrintTemplate h3, #IndicationResultPrintTemplate h4, #IndicationResultPrintTemplate h5, #IndicationResultPrintTemplate h6, #IndicationResultPrintTemplate span, #IndicationResultPrintTemplate strong, #TemplateViewGMTM, #TemplateViewGMTM *:not([class*=" el-icon-"], [class^="el-icon-"]), #TemplateViewGMTM p, #TemplateViewGMTM div, #TemplateViewGMTM b, #TemplateViewGMTM i, #TemplateViewGMTM h1, #TemplateViewGMTM h2, #TemplateViewGMTM h3, #TemplateViewGMTM h4, #TemplateViewGMTM h5, #TemplateViewGMTM h6, #TemplateViewGMTM span, #TemplateViewGMTM strong, #PhieuGayMeViewDetail, #PhieuGayMeViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #TempPhieuChucNangSong, #TempPhieuChucNangSong *:not([class*=" el-icon-"], [class^="el-icon-"]) {font-family: "Times New Roman", "Times", "Tinos", serif !important;}#bienbantemp .content-box, #meetConcludingTemp .content-box, #bienbantemp .content-box p, #meetConcludingTemp .content-box p {font-family: "Times New Roman", "Times", "Tinos", serif !important;font-size: 12px;margin-bottom: 0px;}.content-box, .content-box p, .content-box b, .content-box div, .content-box span, .content-box i, .content-box strong {font-family: "Times New Roman", "Times", "Tinos", serif !important;font-size: 12px;margin-bottom: 0px;}.content-box-10i, .content-box-10i p, .content-box-10i b, .content-box-10i div, .content-box-10i span, .content-box-10i i, .content-box-10i strong {font-family: "Times New Roman", "Times", "Tinos", serif !important;font-size: 10px;margin-bottom: 0px;font-style: italic;}.ck-editor__editable {min-height: 200px;}@media (min-width: 768px) {#page-content-wrapper {min-width: 0;}}.v-toast {z-index: 2011 !important;}.v-toast__item {padding: 5px;justify-content: flex-start;box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);}.v-toast__item--default .v-toast__icon {display: block;width: 64px !important;min-width: 64px !important;height: 64px !important;margin-left: 1em;background: url(../../hodologo_256x256.png) no-repeat !important;background-size: 64px 64px !important;}.v-toast__item--default {background-color: #fff !important;}.v-toast__item--default .v-toast__text {font-family: "Roboto" !important;color: black !important;}.mw-135px {min-width: 135px;}.btn-circle {width: 40px;height: 40px;text-align: center;padding: 0;font-size: 20px;line-height: 40px;border-radius: 20px !important;}.notification-tab {min-width: 200px;}.notification-link {color: #232e3c !important;}.notification-link:hover {text-decoration: none;}.notification-link:hover .row {background: #e3e3e3 !important;border-radius: 5px;}.notification-side {top: 0;bottom: 0;position: fixed;overflow-y: scroll;overflow-x: hidden;width: 300px;right: 0;background-color: #f4f6fa;z-index: 1032;}.notification-side::-webkit-scrollbar {width: 5px;height: 10px;}.notification-side::-webkit-scrollbar-thumb {border-radius: 8px;background-color: #c2c9d2;}.bg-drop {z-index: 1031;width: 100vw;height: 100vh;position: fixed;opacity: 0.5;}.btn {font-weight: 400 !important;}#conversation .ck-editor__editable_inline:focus {color: black;}#conversation .ck-editor__editable_inline {max-height: 120px;line-height: 23px;overflow: auto;min-height: 50px;border-left: none !important;border-right: none !important;}#conversation .ck-toolbar_grouping, #conversation .ck.ck-toolbar__items {border: none !important;background: white;}#ElectronicMedicalRecords .ck-editor__editable_inline {line-height: 24px;overflow: auto;min-height: 64px;}#ElectronicMedicalRecords .ck-toolbar_grouping > .ck-toolbar__items {height: 30px;}#ElectronicMedicalRecords .ck-toolbar_grouping > .ck-toolbar__items > button {min-height: 20px !important;min-width: 20px !important;padding: 0;margin: 0 8px;}#ElectronicMedicalRecords .ck-toolbar__items > .ck-toolbar-dropdown {margin: 0 8px;}#ElectronicMedicalRecords .ck-toolbar__items .ck-dropdown__arrow {height: 12px;width: 12px;}#ElectronicMedicalRecords .ck-toolbar__items .ck-dropdown__button .ck-splitbutton__arrow svg {height: 12px;width: 12px;}#ElectronicMedicalRecords .ck-sticky-panel button > svg {height: 16px;width: 16px;}#ElectronicMedicalRecords .ck-dropdown__panel-visible button > svg {height: 44px;width: 44px;}#ElectronicMedicalRecords .ck-dropdown__panel-visible .ck-toolbar_vertical svg {height: 16px;width: 16px;}.toast-push-notify {max-height: 100px;overflow: hidden;}#tagInputSpcl .tags-input-badge {border-radius: 8px;font-weight: 500;font-size: 14px;padding: 9px 25px 9px 10px;background-color: #e7eaf5;margin: 2px 16px 2px 0px;}#tagRemove .tags-input-remove {font-size: 20px;}#tagRemove .tags-input-remove:after {background: #292d32;}#tagRemove .tags-input-remove:before {background: #292d32;}.form--input {border-radius: 4px;border: none;background-color: #f6f8fb;line-height: 32px;font-size: 14px;font-weight: 500;color: #1d2939;width: 100%;padding: 0 8px;}.el-input__inner {border-radius: 4px !important;border: none !important;background-color: #f6f8fb !important;line-height: 32px !important;font-size: 14px !important;font-weight: 500 !important;color: #1d2939 !important;}.el-input__prefix, .el-input__suffix {color: #1d2939 !important;}.el-date-editor.el-input, .el-date-editor.el-input__inner {width: 100% !important;}.form--input::-webkit-input-placeholder {font-size: 14px;font-weight: 400;}.form--input:-ms-input-placeholder {font-size: 14px;font-weight: 400;}.form--input::placeholder {font-size: 14px;font-weight: 400;}input[type="radio"] {width: 1rem;height: 1rem;}.form--input:focus-visible {outline: solid 1px #20419b !important;}.v-html-p-0 p {margin-bottom: 0 !important;}#TemplatePrescription, #MedicalRecordsExport, #TreatmentViewDetail, #TreatSumsViewDetail, #phieuPhauThuatViewDetail, #PhieuGayMeViewDetail, #PhieuChamSocViewDetail, #CareDetail {}#MedicalRecordsViewDetail .h-detail2 {height: calc(100vh - 11rem);}#MedicalRecordsViewDetail input[type="radio"] {display: none;}#MedicalRecordsViewDetailPage1 .h-detail2 {height: calc(100vh - 11rem);}#MedicalRecordsViewDetailPage1 input[type="radio"] {display: none;}#MedicalRecordsViewDetailPage2 .h-detail2 {height: calc(100vh - 11rem);}#MedicalRecordsViewDetailPage2 input[type="radio"] {display: none;}#MedicalRecordsViewDetailPage3 .h-detail2 {height: calc(100vh - 11rem);}#MedicalRecordsViewDetailPage3 input[type="radio"] {display: none;}#MedicalRecordsViewDetail .border-box {border: 1px solid;}#MedicalRecordsViewDetail .border-bottom-item {border-bottom: 1px solid;}#MedicalRecordsViewDetail .border-right-item {border-right: 1px solid;}#MedicalRecordsViewDetail .box-h-item {min-height: 24px;min-width: 24px;}#MedicalRecordsViewDetail .content-none {width: 80%;border-bottom: 2px dotted;margin-bottom: 6px;}#MedicalRecordsViewDetail .min-h-20 {min-height: 5rem;}#MedicalRecordsViewDetailPage1 .border-box {border: 1px solid;}#MedicalRecordsViewDetailPage1 .border-bottom-item {border-bottom: 1px solid;}#MedicalRecordsViewDetailPage1 .border-right-item {border-right: 1px solid;}#MedicalRecordsViewDetailPage1 .box-h-item {min-height: 24px;min-width: 24px;}#MedicalRecordsViewDetailPage1 .content-none {width: 80%;border-bottom: 2px dotted;margin-bottom: 6px;}#MedicalRecordsViewDetailPage1 .min-h-20 {min-height: 5rem;}#MedicalRecordsViewDetailPage2 .border-box {border: 1px solid;}#MedicalRecordsViewDetailPage2 .border-bottom-item {border-bottom: 1px solid;}#MedicalRecordsViewDetailPage2 .border-right-item {border-right: 1px solid;}#MedicalRecordsViewDetailPage2 .box-h-item {min-height: 24px;min-width: 24px;}#MedicalRecordsViewDetailPage2 .content-none {width: 80%;border-bottom: 2px dotted;margin-bottom: 6px;}#MedicalRecordsViewDetailPage2 .min-h-20 {min-height: 5rem;}#MedicalRecordsViewDetailPage3 .border-box {border: 1px solid;}#MedicalRecordsViewDetailPage3 .border-bottom-item {border-bottom: 1px solid;}#MedicalRecordsViewDetailPage3 .border-right-item {border-right: 1px solid;}#MedicalRecordsViewDetailPage3 .box-h-item {min-height: 24px;min-width: 24px;}#MedicalRecordsViewDetailPage3 .content-none {width: 80%;border-bottom: 2px dotted;margin-bottom: 6px;}#MedicalRecordsViewDetailPage3 .min-h-20 {min-height: 5rem;}th div, td div {word-break: inherit !important;}.el-date-editor .el-range-separator {width: auto !important;}.el-date-editor--daterange {background-color: #fff !important;border-radius: 4px !important;border: 1px solid #dcdfe6 !important;box-sizing: border-box !important;color: #606266 !important;display: inline-block !important;font-size: inherit !important;height: 40px !important;line-height: 40px !important;outline: 0 !important;padding: 0 15px !important;transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;width: 100% !important;}.el-range-editor .el-range-input {background-color: initial;}.el-table__cell div {word-break: break-word !important;}.el-dialog__headerbtn .el-dialog__close {color: #000 !important;font-size: 22px !important;}.hidden-on-pdf {      display: none !important;
    }
    .hodo-print,
    .hodo-print * {
      font-family: "Times New Roman", "Times", "Tinos", serif !important;
      letter-spacing: 0em;
      color: #000000 !important;
    }
    .hodo-print img {
      max-width: 100%;
    }
    .hodo-print img,
    .hodo-print svg {
      vertical-align: middle;
    }
    .hodo-print .content-none {
      width: 100%;
      border-bottom: 2px dotted;
    }
    .hodo-print .font {
      font-family: "Times New Roman", Tinos, Times, serif !important;
    }
    .hodo-print p {
      margin: 0;
    }
    .hodo-print .text-italic {
      font-style: italic;
    }
    .hodo-print .px-8 {
      padding-right: 2rem;
      padding-left: 2rem;
    }
    .hodo-print .overflow-hidden {
      overflow: hidden;
    }
    .hodo-print .float-left {
      float: left;
    }
    .hodo-print .float-right {
      float: right;
    }
    .hodo-print .float-none {
      float: none;
    }
    .hodo-print .block {
      display: block;
    }
    .hodo-print .hidden {
      display: none;
    }
    .hodo-print .inline-block {
      display: inline-block !important;
    }
    .hodo-print .flex {
      display: flex;
    }
    .hodo-print .flex-col {
      flex-direction: column;
    }
    .hodo-print .align-top {
      vertical-align: top;
    }
    .hodo-print .text-center {
      text-align: center;
    }
    .hodo-print .text-left {
      text-align: left;
    }
    .hodo-print .text-right {
      text-align: right;
    }
    .hodo-print .normal-case {
      text-transform: none;
    }
    .hodo-print .uppercase {
      text-transform: uppercase;
    }
    .hodo-print .capitalize {
      text-transform: capitalize;
    }
    .hodo-print .leading-none {
      line-height: 1;
    }
    .hodo-print .align-middle {
      vertical-align: middle;
    }
    .hodo-print .justify-center {
      justify-content: center;
    }
    .hodo-print .justify-end {
      justify-content: end;
    }
    .hodo-print .justify-between {
      justify-content: space-between;
    }
    .hodo-print .items-start {
      align-items: flex-start;
    }
    .hodo-print .items-center {
      align-items: center;
    }
    .hodo-print .col-1 {
      width: 12% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-2 {
      width: 16.6666667% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-3 {
      width: 25% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-4 {
      width: 33.3333333% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-5 {
      width: 41% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-6 {
      width: 50% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-7 {
      width: 58.3333333% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-8 {
      width: 66.666666% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-12 {
      width: 100% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .w-full {
      width: 100% !important;
    }
    .hodo-print .w-half {
      width: 50% !important;
    }
    .hodo-print .w-one-third {
      width: 33.333% !important;
    }
    .hodo-print .w-two-thirds {
      width: 66.667% !important;
    }
    .hodo-print .font-normal {
      font-weight: 400;
    }
    .hodo-print .font-bold {
      font-weight: 700;
    }
    .hodo-print .fs-11,
    .hodo-print .fs-11 *,
    .hodo-print .content-size.fs-11,
    .hodo-print .content-size.fs-11 * {
      font-size: 0.6125rem;
      line-height: 0.75rem;
    }
    .hodo-print .text-xs,
    .hodo-print .text-xs *,
    .hodo-print .fs-12,
    .hodo-print .fs-12 *,
    .hodo-print .content-size.fs-12,
    .hodo-print .content-size.fs-12 * {
      font-size: 0.75rem;
      line-height: 1rem;
    }
    .hodo-print .fs-13,
    .hodo-print .fs-13 *,
    .hodo-print .content-size.fs-13,
    .hodo-print .content-size.fs-13 * {
      font-size: 0.8125rem;
      line-height: 1.25rem;
    }
    .hodo-print .fs-14,
    .hodo-print .fs-14 *,
    .hodo-print .content-size.fs-14,
    .hodo-print .content-size.fs-14 * {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
    .hodo-print .fs-15,
    .hodo-print .fs-15 *,
    .hodo-print .content-size.fs-15,
    .hodo-print .content-size.fs-15 * {
      font-size: 0.9375rem;
      line-height: 1.25rem;
    }
    .hodo-print .text-sm,
    .hodo-print .text-sm * .hodo-print .fs-16,
    .hodo-print .fs-16 *,
    .hodo-print .content-size.fs-16,
    .hodo-print .content-size.fs-16 * {
      font-size: 1rem;
      line-height: 1.25rem;
    }
    .hodo-print .text-base,
    .hodo-print .text-base * {
      font-size: 1rem;
      line-height: 1.5rem;
    }
    .hodo-print .fs-17,
    .hodo-print .fs-17 *,
    .hodo-print .content-size.fs-17,
    .hodo-print .content-size.fs-17 * {
      font-size: 1.0625rem;
      line-height: 1.5rem;
    }
    .hodo-print .text-lg,
    .hodo-print .text-lg *,
    .hodo-print .fs-18,
    .hodo-print .fs-18 *,
    .hodo-print .content-size.fs-18,
    .hodo-print .content-size.fs-18 * {
      font-size: 1.125rem;
      line-height: 1.75rem;
    }
    .hodo-print .fs-19,
    .hodo-print .fs-19 *,
    .hodo-print .content-size.fs-19,
    .hodo-print .content-size.fs-19 * {
      font-size: 1.1875rem;
      line-height: 1.75rem;
    }
    .hodo-print .text-xl,
    .hodo-print .text-xl *,
    .hodo-print .fs-20,
    .hodo-print .fs-20 *,
    .hodo-print .content-size.fs-20,
    .hodo-print .content-size.fs-20 * {
      font-size: 1.25rem;
      line-height: 1.75rem;
    }
    .hodo-print .fs-22,
    .hodo-print .fs-22 *,
    .hodo-print .content-size.fs-22,
    .hodo-print .content-size.fs-22 * {
      font-size: 1.375rem;
      line-height: 1.825rem;
    }
    .hodo-print .text-2xl,
    .hodo-print .text-2xl *,
    .hodo-print .fs-24,
    .hodo-print .fs-24 *,
    .hodo-print .content-size.fs-24,
    .hodo-print .content-size.fs-24 * {
      font-size: 1.5rem;
      line-height: 2rem;
    }
    .hodo-print .my-3 {
      margin-top: 0.75rem;
      margin-bottom: 0.75rem;
    }
    .hodo-print .px-1 {
      padding-left: 0.25rem;
      padding-right: 0.25rem;
    }
    .hodo-print .px-24 {
      padding-left: 6rem !important;
      padding-right: 6rem !important;
    }
    .hodo-print .py-0 {
      padding-top: 0;
      padding-bottom: 0;
    }
    .hodo-print .py-1 {
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
    .hodo-print .pt-12 {
      padding-top: 3rem;
    }
    .hodo-print .p-0 {
      padding: 0;
    }
    .hodo-print .p-1 {
      padding: 0.25rem;
    }
    .hodo-print .p-2 {
      padding: 0.5rem;
    }

    .hodo-print .p-4 {
      padding: 1rem;
    }

    .hodo-print .pt-1 {
      padding-top: 0.25rem;
    }
    .hodo-print .pb-1 {
      padding-bottom: 0.25rem;
    }
    .hodo-print .pb-2 {
      padding-bottom: 0.5rem;
    }
    .hodo-print .pb-20 {
      padding-bottom: 5rem;
    }
    .hodo-print .pl-0 {
      padding-top: 0;
    }
    .hodo-print .pl-0\.5 {
      padding-left: 0.125rem;
    }
    .hodo-print .pl-2 {
      padding-left: 0.5rem;
    }
    .hodo-print .pt-3 {
      padding-top: 0.75rem;
    }
    .hodo-print .pl-3 {
      padding-left: 0.75rem !important;
    }
    .hodo-print .pl-12 {
      padding-left: 3rem;
    }
    .hodo-print .pl-16 {
      padding-left: 4rem;
    }
    .hodo-print .pl-1 {
      padding-left: 0.25rem;
    }
    .hodo-print .pr-0 {
      padding-right: 0;
    }
    .hodo-print .pr-12 {
      padding-right: 3rem;
    }
    .hodo-print .pr-16 {
      padding-right: 4rem;
    }
    .hodo-print .pr-20 {
      padding-right: 5rem;
    }
    .hodo-print .-mt-1 {
      margin-top: -0.25rem;
    }
    .hodo-print .mt-1 {
      margin-top: 0.25rem;
    }
    .hodo-print .mt-2 {
      margin-top: 0.5rem;
    }
    .hodo-print .mt-3 {
      margin-top: 0.75rem;
    }
    .hodo-print .mt-4 {
      margin-top: 1rem;
    }
    .hodo-print .m-6 {
      margin: 1.5rem;
    }
    .hodo-print .ml-6 {
      margin-left: 1.5rem;
    }
    .hodo-print .mt-6 {
      margin-top: 1.5rem;
    }
    .hodo-print .mt-8 {
      margin-top: 2rem;
    }
    .hodo-print .mt-10 {
      margin-top: 2.5rem;
    }
    .hodo-print .mt-12 {
      margin-top: 3rem;
    }
    .hodo-print .mt-16 {
      margin-top: 4rem;
    }
    .hodo-print .mb-16 {
      margin-bottom: 4rem;
    }
    .hodo-print .mt-20 {
      margin-top: 5rem;
    }
    .hodo-print .mt-24 {
      margin-top: 6rem;
    }
    .hodo-print .mt-44 {
      margin-top: 11rem;
    }
    .hodo-print .ml-auto {
      margin-left: auto;
    }
    .hodo-print .-ml-0\.25 {
      margin-left: -1.5px;
    }
    .hodo-print .mx-1 {
      margin-left: 0.25rem;
      margin-right: 0.25rem;
    }
    .hodo-print .ml-1 {
      margin-left: 0.25rem;
    }
    .hodo-print .ml-2 {
      margin-left: 0.5rem;
    }
    .hodo-print .ml-3 {
      margin-left: 0.75rem;
    }
    .hodo-print .ml-3\.5 {
      margin-left: 0.875rem;
    }
    .hodo-print .ml-4 {
      margin-left: 1rem;
    }
    .hodo-print .ml-5 {
      margin-left: 1.25rem;
    }
    .hodo-print .ml-24 {
      margin-left: 6rem;
    }
    .hodo-print .mr-0\.25 {
      margin-right: 1.5px;
    }
    .hodo-print .mr-1 {
      margin-right: 0.25rem;
    }
    .hodo-print .mr-3 {
      margin-right: 0.75rem;
    }
    .hodo-print .mb-0 {
      margin-bottom: 0;
    }
    .hodo-print .mb-0\.5 {
      margin-bottom: 0.125rem;
    }
    .hodo-print .mb-1 {
      margin-bottom: 0.25rem;
    }
    .hodo-print .mb-2 {
      margin-bottom: 0.5rem;
    }
    .hodo-print .mb-3 {
      margin-bottom: 0.75rem;
    }
    .hodo-print .mb-6 {
      margin-bottom: 1.5rem;
    }
    .hodo-print .mb-8 {
      margin-bottom: 2rem;
    }
    .hodo-print .hodo-table figure {
      margin: 0 0 1rem !important;
    }
    .hodo-print .hodo-table table {
      border-collapse: collapse !important;
      width: 100% !important;
      border: 1px solid #7d7d7e !important;
      margin-top: 1rem !important;
    }
    .hodo-print .hodo-table.border-black table {
      border-color: black !important;
    }
    .hodo-print .hodo-table table thead th {
      text-transform: uppercase !important;
    }
    .hodo-print .hodo-table table td,
    .hodo-print .hodo-table table th {
      padding: 8px !important;
      border: 1px solid #7d7d7e !important;
    }
    .hodo-print .hodo-table.border-black table td,
    .hodo-print .hodo-table.border-black table th {
      border-color: black !important;
    }

    .hodo-print .hodo-table table td p {
      min-height: 25px !important;
    }
    .hodo-table-cs tbody tr:nth-child(2) td:first-child {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    .hodo-table-cs tbody tr:nth-child(2) td:first-child p {
      margin-bottom:4px
    }

    .hodo-table-cs tbody tr:nth-child(2) td:nth-child(2) p,
    .hodo-table-cs tbody tr:nth-child(2) td:nth-child(3) p {
      min-height: 35px !important;
      min-width: 45px !important;
    }


    .hodo-print .table-width-full table {
      width: 100% !important;
    }
    .hodo-print .el-table--border,
    .hodo-print .el-table--group {
      border-top: 1px solid #000;
      border-right: 1px solid #000;
      border-left: 1px solid #000;
    }
    .hodo-print .el-table th.el-table__cell.is-leaf {
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
    }
    .hodo-print .el-table__row:last-child,
    .hodo-print .el-table__cell:last-child,
    .hodo-print .el-table th.el-table__cell.is-leaf:last-child {
      border-right: none;
    }
    .hodo-print .el-table__cell {
      border-bottom: 1px solid #000;
      border-right: 1px solid #000;
    }
    .hodo-print .el-table--border th.el-table__cell > div.cell {
      line-height: 1.25 !important;
    }
    .hodo-print thead th.padding-header {
      padding: 0 8px !important;
    }
    .hodo-print thead th.header-text-left {
      text-align: left !important;
      padding: 0 8px !important;
    }
    .hodo-print .break-words {
      overflow-wrap: break-word !important;
      word-break: break-word !important;
      word-wrap: break-word !important;
      white-space: break-spaces !important;
    }
    .hodo-print .border-box {
      border: 1px solid #000;
    }
    .hodo-print .border {
      border: 1px solid #e0e0e0 !important;
    }
    .hodo-print .border-t {
      border-top: 1px solid #000;
    }
    .hodo-print .border-b {
      border-bottom: 1px solid #000;
    }
    .hodo-print .border-b-cs {
      border-bottom: 1px solid #7d7d7e;
    }
    .hodo-print .border-l {
      border-left: 1px solid #000;
    }
    .hodo-print .border-r {
      border-right: 1px solid #000;
    }
    .relative {
      position: relative;
    }
    .absolute {
      position: absolute;
    }
    .top-0 {
      top: 0;
    }
    .right-0 {
      right: 0;
    }
    .bottom-0 {
      bottom: 0;
    }
    .left-0 {
      left: 0;
    }
    .whitespace-nowrap {
      white-space: nowrap;
    }
    .overflow-hidden {
      overflow: hidden;
    }
    .float-left {
      float: left;
    }
    .float-right {
      float: right;
    }
    .float-none {
      float: none;
    }
    .block {
      display: block;
    }
    .inline-block {
      display: inline-block;
    }
    .flex {
      display: flex;
    }
    .flex-col {
      flex-direction: column;
    }
    .align-top {
      vertical-align: top;
    }
    .text-center {
      text-align: center;
    }
    .text-left {
      text-align: left;
    }
    .text-right {
      text-align: right;
    }
    .normal-case {
      text-transform: none;
    }
    .uppercase {
      text-transform: uppercase;
    }
    .capitalize {
      text-transform: capitalize;
    }
    .leading-none {
      line-height: 1;
    }
    .align-middle {
      vertical-align: middle;
    }
    .justify-center {
      justify-content: center;
    }
    .justify-end {
      justify-content: end;
    }
    .justify-between {
      justify-content: space-between;
    }
    .items-start {
      align-items: flex-start;
    }
    .items-center {
      align-items: center;
    }
    .box-number {
      border: 1px solid black;
      height: 1.5rem !important;
    }
    .box-item {
      font-family: "Times New Roman", Tinos, Times, serif !important;
      height: 1.5rem !important;
      width: 1.5rem !important;
      border-right: 1px solid black;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .box-item-bhyt {
      font-family: "Times New Roman", Tinos, Times, serif !important;
      height: 1.5rem !important;
      min-width: 1.5rem !important;
      width: 100%;
      padding: 2px;
      border-right: 1px solid black;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .box-item-bhyt:last-child,
    .box-item:last-child {
      border-right: none;
    }
    .checkbox {
      display: inline-flex;
      cursor: pointer;
      position: relative;
    }
    .html2pdf__page-break {
      page-break-before: always;
    }
    .italic {
      font-style: italic;
    }
    .not-italic {
      font-style: normal;
    }
    .w-3 {
      width: 0.75rem;
    }
    .h-3 {
      height: 0.75rem;
    }
    .w-24 {
      width: 6rem;
    }
    .h-24 {
      height: 6rem;
    }
    .w-40 {
      width: 10rem;
    }
    .h-40 {
      height: 10rem;
    }
    .cursor-pointer {
      cursor: pointer;
    }
    .cursor-default {
      cursor: default;
    }
    .min-h-250 {
      min-height: 250px;
    }
    .min-h-350 {
      min-height: 350px;
    }
    .hodo-print .border-box-table {
      border-top: 1px solid black;
      border-left: 1px solid black;
    }
    .hodo-print .border-bottom-item-table {
      border-bottom: 1px solid black;
    }
   .hodo-print .border-right-item-table {
      border-right: 1px solid black;
    }
    .hodo-print .box-nv {
      position: relative;
      border: 1px solid black;
      margin-top: 4px;
    }

    .hodo-print .el-icon-close {
      position: absolute;
      right: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 0.75rem;
      height: 0.75rem;
      opacity: 1;
    }
    .hodo-print .el-icon-close:before, .el-icon-close:after {
      position: absolute;
      left: 1.1rem;
      content: ' ';
      height: 0.75rem;
      width: 2px;
      background-color: #333;
    }
    .hodo-print .el-icon-close:before {
      transform: rotate(45deg);
    }
    .hodo-print .el-icon-close:after {
      transform: rotate(-45deg);
    }x
    .hodo-print .el-center {
      position: absolute;
      content: "";
      right: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .hodo-print .w-fit{
      width: fit-content;
    }
    .hodo-print .flex-1{
      flex: 1;
    }

    .hodo-print .ql-syntax {
      background-color: #23241f;
      color: #f8f8f2;
      overflow: visible;
    }

    .hodo-print .ql-align-center{
      text-align: center;
    }

    .hodo-print .ql-align-right{
      text-align: right;
    }

    .hodo-print .ql-align-left{
      text-align: left;
    }

    .object-contain{
      object-fit: contain;
    }

    .hodo-print .mx-auto {
      margin-left: auto;
      margin-right: auto;
    }

    .hodo-print .content-none-cs{
      margin-bottom: 0.25rem;
    }

    #phieukham *{
      font-size:20px
    }

    #phieukham h1 *{
      font-size:28px !important
     }

     #phieukham h1{
        margin-bottom:30px !important;
        display:block !important
     }

     #phieukham p{
      margin-bottom:12px
     }
     #phieukham table{
      width:100% !important
     }

     #phieukham tbody{
       width:100% !important
      }

     #phieukham tr{
      display:block !important;
      width:100% !important;
      min-height:90px
     }

     #phieukham td:first-child p *{
      font-size:16px !important;
     }

     #phieukham td:first-child p{
      margin-bottom:0 !important;
     }

     #phieukham td:first-child{
      width:250px !important
     }

     #phieukham td:nth-child(2) p{
       margin-bottom:0 !important;
      }
      #phieukham td:nth-child(2) p *{
        font-size:18px !important;
      }
      #phieukham td:nth-child(2){
       margin-right:0px !important;
       display:block !important;
       width:650px !important;
      }
      #phieukham td:nth-child(3){
        vertical-align:top;
        width:240px !important;
      }
      #phieukham td:nth-child(3) * {
        font-size:18px !important;
        display:block;
        width:100%;
        height:100%;
       }

       #phieukham td:nth-child(3) p:first-child {
          margin-bottom:0 !important
       }

       #phieukham td:nth-child(3) p:last-child *{
          font-size:22px !important
      }

      .invisible{
        visibility:hidden;
      }
      #phieuChuyenTuyen *{
        font-family: "Times New Roman", "Times", "Tinos", serif !important;
      }
      #giayChungNhan *{
        font-family: "Times New Roman", "Times", "Tinos", serif !important;
      }
      #phieuPhauThuatViewDetail #table_phieu_phau_thuat > *{
        overflow: visible,
        break-inside: avoid;
        display: block;
        page-break-inside: auto;
      }
      #phieuPhauThuatViewDetail #table_phieu_phau_thuat thead tr {
        width: 100%;
        display:flex;
      }
      #phieuPhauThuatViewDetail #table_phieu_phau_thuat thead tr td{
        width: 50%;
      }
      #phieuPhauThuatViewDetail #table_phieu_phau_thuat tbody tr {
        width: 100%;
        display: flex;
      }
      #phieuPhauThuatViewDetail #table_phieu_phau_thuat tbody tr td {
        width: 50%;
      }
    </style></head><body>${bodyHTML}</body></html>`
    return template
  },
  formatInputDate (dateTime) {
    if (!dateTime) return Vue.prototype.moment().format('YYYY-MM-DD')
    return Vue.prototype.moment(dateTime).format('YYYY-MM-DD')
  },
  formatInputDateTime (dateTime) {
    if (!dateTime) return Vue.prototype.moment().format('YYYY-MM-DD HH:mm:ss')
    return Vue.prototype.moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
  },
  formatInputDateTimeUTC (dateTime) {
    if (!dateTime) {
      return Vue.prototype.moment().utc().format('YYYY-MM-DD HH:mm:ss')
    }
    return Vue.prototype.moment(dateTime).utc().format('YYYY-MM-DD HH:mm:ss')
  },
  formatDateTimeUTCTz (dateTime) {
    if (!dateTime) {
      return Vue.prototype.moment().utc().format('YYYY-MM-DDTHH:mm:ssZ')
    }
    return Vue.prototype.moment(dateTime).utc().format('YYYY-MM-DDTHH:mm:ssZ')
  },
  formatDateTime (
    dateTime,
    options = {
      format: 'HH:mm DD/MM/YYYY',
      isUTC: false,
      isLocal: false,
      locale: Vue.prototype.$lang || 'vi'
    }
  ) {
    // console.log(options?.locale)
    if (!dateTime) {
      return ''
    }
    if (options?.isUTC && options?.isLocal) {
      return Vue.prototype.moment
        .utc(dateTime)
        .local()
        .locale(options?.locale || 'vi')
        .format(options?.format)
    }
    if (options?.isUTC && !options?.isLocal) {
      return Vue.prototype.moment
        .utc(dateTime)
        .locale(options?.locale || 'vi')
        .format(options?.format)
    }
    return Vue.prototype
      .moment(dateTime)
      .locale(options?.locale || 'vi')
      .format(options?.format)
  },
  formatDateTimeUTC (dateTime) {
    if (!dateTime) return Vue.prototype.moment().format('HH:mm DD/MM/YYYY')
    return Vue.prototype.moment(dateTime).utc().format('HH:mm DD/MM/YYYY')
  },
  formatDateTimeFull (dateTime) {
    if (!dateTime) {
      return Vue.prototype.moment().format('HH:mm:ss DD/MM/YYYY')
    }
    return Vue.prototype.moment(dateTime).format('HH:mm:ss DD/MM/YYYY')
  },
  formatTime (dateTime, isUTC) {
    if (!dateTime) {
      return Vue.prototype.moment().format('HH:mm').replace(':', 'h')
    }
    if (isUTC) {
      return Vue.prototype.moment.utc(dateTime).local().format('HH:mm').replace(':', 'h')
    }
    return Vue.prototype.moment(dateTime).format('HH:mm').replace(':', 'h')
  },
  formatSimpleTime (dateTime) {
    if (!dateTime) {
      return Vue.prototype.moment().format('HH:mm')
    }
    return Vue.prototype.moment(dateTime).format('HH:mm')
  },
  formatDate (dateTime, isUTC) {
    if (!dateTime) return Vue.prototype.moment().format('DD/MM/YYYY')
    if (isUTC) {
      return Vue.prototype.moment.utc(dateTime).local().format('DD/MM/YYYY')
    }
    return Vue.prototype.moment(dateTime).format('DD/MM/YYYY')
  },
  formatSimpleDate (dateTime) {
    if (!dateTime) return Vue.prototype.moment().format('D/M')
    return Vue.prototype.moment(dateTime).format('D/M')
  },
  formatDuration (s, e) {
    let start = Vue.prototype.moment(s)
    let end = Vue.prototype.moment(e)
    var duration = Vue.prototype.moment.duration(end.diff(start))
    return duration.asMinutes()
  },
  formatToCurrency ({ amount, locale = 'vi-VN', currency = 'VND' }) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(Number(amount))

    // return amount.toFixed(fixed).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  },
  formatMoney (amount, decimalCount = 2, decimal = '.', thousands = ',') {
    try {
      decimalCount = Math.abs(decimalCount)
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount

      const negativeSign = amount < 0 ? '-' : ''

      amount = Math.abs(Number(amount) || 0)

      let i = parseInt(floor10(amount, -decimalCount)).toString()
      let j = i.length > 3 ? i.length % 3 : 0

      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
        (decimalCount
          ? decimal +
            floor10(Math.abs(amount - Number(i)), -decimalCount)
              .toString()
              .slice(2)
          : '')
      )
    } catch (e) {
      console.log(e)
    }
  },
  table12Weeks () {
    return `<div><table style="width:100%"><tbody><tr><td style="font-weight:700">KCC</td><td>...../...../ 2023</td><td style="font-weight:700">Tuổi thai theo KCC:</td><td>.....tuần .....ngày</td></tr><tr><td style="font-weight:700">Ngày DKS</td><td>...../...../ 2023</td><td style="font-weight:700">Tuổi thai theo DKS:</td><td>.....tuần .....ngày</td></tr></tbody></table><table style="width:100%"><thead><tr><th colspan="4" style="font-size:20px;font-weight:700;text-align:center;text-transform:uppercase">SIÊU ÂM THAI HÌNH THÁI THAI DƯỚI 12 TUẦN</th></tr></thead><tbody><tr><td style="font-weight:700"><span>Tư thế tử cung</span></td><td style="text-align:center"></td><td style="font-weight:700"><span>GS (mm)</span></td><td style="text-align:center"></td></tr><tr><td style="font-weight:700"><span>KT (mm)</span></td><td style="text-align:center"></td><td style="font-weight:700"><span>CRL (mm)</span></td><td style="text-align:center"></td></tr><tr><td style="font-weight:700" rowspan="2"><span>Buồng tử cung</span></td><td style="text-align:center" rowspan="2"></td><td style="font-weight:700"><span>BPD (mm)</span></td><td style="text-align:center">&nbsp;</td></tr><tr><td style="font-weight:700"><span>FL (mm)</span></td><td style="text-align:center"></td></tr><tr><td style="font-weight:700"><span>Số lượng thai</span></td><td style="text-align:center"></td><td style="font-weight:700"><span>KSSG (mm)</span></td><td style="text-align:center"></td></tr><tr><td style="font-weight:700"><span>Tim thai</span></td><td style="text-align:center"></td><td style="font-weight:700"><span>Xương sống mũi</span></td><td style="text-align:center"></td></tr><tr><td style="font-weight:700"><span>Nước ối</span></td><td style="text-align:center"><span>Bình thường</span></td><td style="font-weight:700"><span>Bánh rau</span></td><td style="text-align:center"><span>Bám rộng</span></td></tr><tr><td style="font-weight:700"><span>H/a khác</span></td><td colspan="3" style="text-align:center"></td></tr><tr><td style="font-weight:700" colspan="4"><span>Ngày dự kiến sinh:</span></td></tr><tr><td colspan="4" style="text-transform:uppercase"><strong>HẸN TUẦN SIÊU ÂM LẠI</strong></td></tr><tr><td colspan="4" style="font-style:italic">Khi khám lại nhớ mang theo kết quả này.</td></tr><tr><td colspan="4" style="font-style:italic">Các thời điểm siêu âm quan trọng: thai 12 tuần, 22 tuần, 32 tuần.</td></tr><tr><td colspan="4" style="font-style:italic">Đề nghị làm Double-Test vào thời điểm thai 11-13 tuần.</td></tr><tr><td colspan="4" style="font-style:italic">Làm Triple-Test vào thời điểm thai 16-18 tuần.</td></tr></tbody></table></div>`
  },
  table15Weeks () {
    return `<div><table style="width:100%"><tbody><tr><td style="font-weight:700">KCC</td><td>...../...../ 2023</td><td style="font-weight:700">Tuổi thai theo KCC:</td><td>.....tuần .....ngày</td></tr><tr><td style="font-weight:700">Ngày DKS</td><td>...../...../ 2023</td><td style="font-weight:700">Tuổi thai theo DKS:</td><td>.....tuần .....ngày</td></tr></tbody></table><table style="width:100%"><thead><tr><th colspan="6" style="font-size:20px;font-weight:700;text-align:center;text-transform:uppercase">SIÊU ÂM THAI HÌNH THÁI THAI 15 - 17 TUẦN</th></tr></thead><tbody><tr><td style="font-weight:700">BPD</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Tiểu não</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Dạ dày</td><td style="text-align:center">Bên trái</td></tr><tr><td style="font-weight:700">HC</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Hố sau</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Cột sống</td><td style="text-align:center">Bình thường</td></tr><tr><td style="font-weight:700">AC</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">NT bên</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Bàn chân</td><td style="text-align:center">Không vẹo</td></tr><tr><td style="font-weight:700">TAD</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Hố mắt</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Bàn tay</td><td style="text-align:center">Bình thường</td></tr><tr><td style="font-weight:700">FL</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">X sống mũi</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Ngón tay</td><td style="text-align:center">Bình thường</td></tr><tr><td colspan="4" style="font-weight:700;text-align:center">Tần số tim thai: lần/phút</td><td colspan="2" style="font-weight:700;text-align:center">Bánh rau</td></tr><tr><td style="font-weight:700">Vị trí tim</td><td style="text-align:center">trái</td><td style="font-weight:700">Gờ NTM</td><td style="text-align:center">Có</td><td style="font-weight:700">Vị trí</td><td style="text-align:center"></td></tr><tr><td style="font-weight:700">Trục tim</td><td style="text-align:center">trái</td><td style="font-weight:700">Doppler qua van 3 lá</td><td style="text-align:center">Bình thường</td><td style="font-weight:700">Dây rốn bám</td><td style="text-align:center"></td></tr><tr><td colspan="2" style="font-weight:700">Doppler CVA</td><td colspan="2" style="text-align:center">Có sóng a</td><td style="font-weight:700">Nước ối</td><td style="text-align:center">Bình thường</td></tr><tr><td colspan="2" style="font-weight:700">Cân nặng ước tính</td><td colspan="2" style="text-align:center"></td><td>RI ĐMTC (P):&nbsp;</td><td>RI ĐMTC (T):&nbsp;</td></tr><tr><td colspan="2" style="font-weight:700">H/a khác</td><td colspan="4" style="text-align:center"></td></tr></tbody></table></div>`
  },
  table18Weeks () {
    return `<div><table style="width:100%"><tbody><tr><td style="font-weight:700">KCC</td><td>...../...../ 2023</td><td style="font-weight:700">Tuổi thai theo KCC:</td><td>.....tuần .....ngày</td></tr><tr><td style="font-weight:700">Ngày DKS</td><td>...../...../ 2023</td><td style="font-weight:700">Tuổi thai theo DKS:</td><td>.....tuần .....ngày</td></tr></tbody></table><table style="width:100%"><thead><tr><th colspan="6" style="font-size:20px;font-weight:700;text-align:center;text-transform:uppercase"><div>SIÊU ÂM THAI 18 - 22 TUẦN</div><div>SIÊU ÂM CẤU TRÚC TIM THAI</div></th></tr></thead><tbody><tr><td style="font-weight:700">BPD</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Tiểu não</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Dạ dày</td><td style="text-align:center">Bên trái</td></tr><tr><td style="font-weight:700">HC</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Hố sau</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Cột sống</td><td style="text-align:center">Bình thường</td></tr><tr><td style="font-weight:700">AC</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">NT bên</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Bàn chân</td><td style="text-align:center">&nbsp;mm</td></tr><tr><td style="font-weight:700">TAD</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Thùy nhộng</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Chi trên</td><td style="text-align:center">3 đoạn</td></tr><tr><td style="font-weight:700">FL</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Hố mắt</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Bàn tay</td><td style="text-align:center">Mở</td></tr><tr><td style="font-weight:700">HL</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">X sống mũi</td><td style="text-align:right">&nbsp;mm</td><td style="font-weight:700">Ngón tay</td><td style="text-align:center">5</td></tr><tr><td colspan="4" style="font-weight:700;text-align:center">Tần số tim thai: lần/phút</td><td colspan="2" style="font-weight:700;text-align:center">Bánh rau</td></tr><tr><td style="font-weight:700">Vị trí tim</td><td style="text-align:center">trái</td><td style="font-weight:700">Gờ NTM</td><td style="text-align:center">Có</td><td style="font-weight:700">Vị trí</td><td style="text-align:center"></td></tr><tr><td style="font-weight:700">Trục tim</td><td style="text-align:center">trái</td><td style="font-weight:700">VLT</td><td style="text-align:center">Bình thường</td><td style="font-weight:700">Dây rốn bám</td><td style="text-align:center"></td></tr><tr><td style="font-weight:700">Đm chủ</td><td style="text-align:center">&nbsp;mm</td><td style="font-weight:700">Di động van</td><td style="text-align:center">Bình thường</td><td style="font-weight:700">Nước ối</td><td style="text-align:center">Bình thường</td></tr><tr><td style="font-weight:700">Đm phổi</td><td style="text-align:center">&nbsp;mm</td><td style="font-weight:700">Nốt Canxi</td><td style="text-align:center">Không có</td><td>RI ĐMTC (P):&nbsp;</td><td>RI ĐMTC (T):&nbsp;</td></tr><tr><td colspan="2" style="font-weight:700">Cân nặng ước tính</td><td colspan="4" style="text-align:center">.....gr</td></tr><tr><td colspan="2" style="font-weight:700">H/a khác</td><td colspan="4" style="text-align:center"></td></tr></tbody></table></div>`
  },
  table34Weeks () {
    return `<div><table style="width:100%"><tbody><tr><td style="font-weight:700">Ngày DKS</td><td>...../...../ 2023</td><td style="font-weight:700">Tuổi thai:</td><td>.....tuần .....ngày</td></tr></tbody></table><table style="width:100%"><thead><tr><th colspan="7" style="font-size:20px;font-weight:700;text-align:center;text-transform:uppercase">SIÊU ÂM DOPPLER - ĐÁNH GIÁ TĂNG TRƯỞNG CỦA THAI</th></tr></thead><tbody><tr><td style="font-weight:700">Số lượng thai</td><td colspan="4">01</td><td style="font-weight:700">Tim</td><td>4 buồng</td></tr><tr><td style="font-weight:700">Cử động thai</td><td colspan="4">(+++)</td><td style="font-weight:700">Vách liên thất</td><td>Bình thường</td></tr><tr><td style="font-weight:700">Ngôi thai</td><td colspan="4"></td><td style="font-weight:700">Nhịp tim thai</td><td>140 l/p</td></tr><tr><td style="font-weight:700">ĐK lưỡng đỉnh (BPD)</td><td style="text-align:center"></td><td>mm</td><td style="text-align:center"></td><td>pct</td><td style="font-weight:700">Phổi 2 bên</td><td>Bình thường</td></tr><tr><td style="font-weight:700">Chu vi đầu (HC)</td><td style="text-align:center"></td><td>mm</td><td style="text-align:center"></td><td>pct</td><td style="font-weight:700">Hình ảnh dạ dày</td><td>(+)</td></tr><tr><td style="font-weight:700">ĐK ngang bụng (TAD)</td><td style="text-align:center"></td><td>mm</td><td style="text-align:center"></td><td>pct</td><td style="font-weight:700">Thận 2 bên</td><td>Bình thường</td></tr><tr><td style="font-weight:700">Chu vi bụng (AC)</td><td style="text-align:center"></td><td>mm</td><td style="text-align:center"></td><td>pct</td><td style="font-weight:700">Bàng quang</td><td>(+)</td></tr><tr><td style="font-weight:700">Chiều dài xương đùi FL</td><td style="text-align:center"></td><td>mm</td><td style="text-align:center"></td><td>pct</td><td style="font-weight:700">Cột sống</td><td>Bình thường</td></tr><tr><td style="font-weight:700">Chiều dài x cánh tay HL</td><td style="text-align:center"></td><td>mm</td><td style="text-align:center"></td><td>pct</td><td style="font-weight:700">Môi, mũi</td><td>Bình thường</td></tr><tr><td style="font-weight:700">Cân nặng</td><td style="text-align:center"></td><td>gr</td><td style="text-align:center"></td><td>pct</td><td colspan="2"></td></tr></tbody></table><table style="width:100%"><tbody><tr><td>RI Đ/M não:&nbsp;</td><td>RI Đ/M rốn:&nbsp;</td><td colspan="2" style="font-weight:700">Vị trí BR</td><td colspan="2" style="text-align:center">mặt</td></tr><tr><td style="font-weight:700">CS não rốn</td><td style="text-align:center"></td><td colspan="2" style="font-weight:700">Độ dày bánh rau</td><td colspan="2" style="text-align:center">&nbsp;mm</td></tr><tr><td style="font-weight:700">Ống TM Arantius</td><td style="text-align:center"></td><td colspan="2" style="font-weight:700">Canxi hóa bánh rau</td><td colspan="2" style="text-align:center">Độ:&nbsp;</td></tr><tr><td style="font-weight:700">RI động mạnh TC (T)</td><td style="text-align:center"></td><td style="font-weight:700">CSO</td><td style="text-align:center">&nbsp;mm</td><td style="font-weight:700">CA ối</td><td style="text-align:center">BT</td></tr><tr><td style="font-weight:700">RI động mạnh TC (P)</td><td style="text-align:center"></td><td style="font-weight:700">DR Quấn cổ</td><td style="text-align:center">0</td><td colspan="2">2 ĐM, 1 TM</td></tr><tr><td colspan="2" style="font-weight:700">H/a khác</td><td colspan="4" style="text-align:center"></td></tr><tr><td colspan="6" style="text-transform:uppercase"><strong>CÁC DẤU HIỆU CẦN LƯU Ý</strong></td></tr><tr><td colspan="6" style="font-style:italic">Cử động thai bất thường</td></tr><tr><td colspan="6" style="font-style:italic">Đau bụng cơn tăng dần</td></tr><tr><td colspan="6" style="font-style:italic">Ra nước hoặc ra máu</td></tr></tbody></table></div>`
  },
  tableMedicalOrder () {
    return `<table style="min-width: 810px;"> <colgroup> <col style="width: 228px;"/> <col style="width: 100px;"/> <col style="width: 89px;"/> <col style="width: 91px;"/> <col style="width: 252px;"/> </colgroup> <tbody> <tr> <th colspan="7" rowspan="1" colwidth="228,100,89,91,252"><p style="text-align: center;">Y LỆNH</p></th> </tr><tr> <th colspan="1" rowspan="1" colwidth="228"><p style="text-align: center;">Thuốc điều trị</p></th> <th colspan="1" rowspan="1" colwidth="100"><p style="text-align: center;">Liều (mg)</p></th> <th colspan="1" rowspan="1" colwidth="89"><p style="text-align: center;">Số lượng</p></th> <th colspan="1" rowspan="1" colwidth="91"><p style="text-align: center;">Thể tích</p></th> <th colspan="1" rowspan="1" colwidth="252"><p style="text-align: center;">Hướng dẫn thực hiện</p></th> <th colspan="1" rowspan="1"><p style="text-align: center;">Giờ bắt đầu</p></th> <th colspan="1" rowspan="1"><p style="text-align: center;">Giờ kết thúc</p></th> </tr><tr> <td colspan="1" rowspan="1" colwidth="228"><p></p></td><td colspan="1" rowspan="1" colwidth="100"> <p></p></td><td colspan="1" rowspan="1" colwidth="89"><p style="text-align: center;"></p></td><td colspan="1" rowspan="1" colwidth="91"> <p></p></td><td colspan="1" rowspan="1" colwidth="252"><p></p></td><td colspan="1" rowspan="1"> <p></p></td><td colspan="1" rowspan="1"> <p></p></td></tr><tr> <td colspan="1" rowspan="1" colwidth="228"><p></p></td><td colspan="1" rowspan="1" colwidth="100"> <p></p></td><td colspan="1" rowspan="1" colwidth="89"><p style="text-align: center;"></p></td><td colspan="1" rowspan="1" colwidth="91"> <p></p></td><td colspan="1" rowspan="1" colwidth="252"><p></p></td><td colspan="1" rowspan="1"> <p></p></td><td colspan="1" rowspan="1"> <p></p></td></tr><tr> <td colspan="1" rowspan="1" colwidth="228"><p></p></td><td colspan="1" rowspan="1" colwidth="100"> <p></p></td><td colspan="1" rowspan="1" colwidth="89"><p style="text-align: center;"></p></td><td colspan="1" rowspan="1" colwidth="91"> <p></p></td><td colspan="1" rowspan="1"> <p></p></td><td colspan="1" rowspan="1"> <p></p></td><td colspan="1" rowspan="1"> <p></p></td></tr></tbody></table>`
  },
  convertSlug (text, replacement = '-') {
    if (!text || typeof text === 'undefined') return
    return slugify(text, {
      replacement, // replace spaces with replacement character, defaults to `-`
      remove: /[*+~.()'"!:@]/g, // remove characters that match regex, defaults to `undefined`
      lower: true, // convert to lower case, defaults to `false`
      strict: true, // strip special characters except replacement, defaults to `false`
      locale: 'vi' // language code of the locale to use
    })
  },
  groupBy (collection, property) {
    var i = 0,
      val,
      index,
      values = [],
      result = []
    for (; i < collection.length; i++) {
      val = collection[i][property]
      index = values.indexOf(val)
      if (index > -1) {
        result[index].push(collection[i])
      } else {
        values.push(val)
        result.push([collection[i]])
      }
    }
    return result
  },
  groupByKey (list, key, { omitKey = false }) {
    return list.reduce(
      (hash, { [key]: value, ...rest }) => ({
        ...hash,
        [value]: (hash[value] || []).concat(omitKey ? { ...rest } : { [key]: value, ...rest })
      }),
      {}
    )
  },
  isImage (file) {
    if (!file) return false
    if (file?.url && /(getimagefile)/.test(file?.url)) {
      return true
    }

    if (file instanceof File) {
      return !!file.type.match('image.*')
    }

    const extensions = ['jpg', 'jpeg', 'png', 'tiff', 'bmp', 'svg']
    const extVal = file?.split('.').pop().toLowerCase() || file?.file_name?.split('.').pop().toLowerCase()

    return extensions.includes(extVal)
  },
  isPdf (file) {
    if (!file) return false
    if (file instanceof File) {
      return !!file.type.match('application/pdf')
    }
    const extVal = file?.split('.').pop().toLowerCase()
    return extVal === 'pdf'
  },
  getExtensionOfFile (filename) {
    if (!filename) return
    return filename?.split('.').pop().toLowerCase()
  },
  getRandomColor () {
    var letters = '0123456789ABCDEF'
    var color = '#'
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  },
  convertRolesName (roleName) {
    if (!roleName || typeof roleName === 'undefined' || !roleName.length) {
      return
    }
    const role = this.convertSlug(roleName, '-')
    return role
  },
  isJSON (data) {
    try {
      JSON.parse(data)
    } catch (error) {
      return false
    }
    return true
  },
  isDate (data) {
    return new Date(data) instanceof Date && !isNaN(new Date(data).getTime())
  },
  onClearUser () {
    this.removeLocalToken()
    this.removeLocalUser()
    this.removeClinicId()
    this.removeDoctorClinic()
    this.removeGlobalOrg()
    this.removeFirebaseAccessToken()
    rolesPermissions.removePermissionsList()
    rolesPermissions.rmRole()
    window.localStorage.removeItem('isAdmin')
    window.localStorage.removeItem('app_mode')

    try {
      firebase.messaging().deleteToken()
    } catch (e) {
      // statements
      console.log(e)
    }
    if (window.client) {
      window.client.disconnect()
      setTimeout(() => {
        window.client = null
      }, 300)
    }
  },
  isToday (value) {
    const today = new Date()
    const date = new Date(value)
    if (today?.toDateString() === date?.toDateString()) {
      return true
    }
    return false
  },
  checkIsMobile () {
    return isMobile
  },
  checkIsSafari () {
    return isSafari
  },
  onHandleErrorLoadImage (e, customImage) {
    e.target.src = customImage || defaultImage
    e.onerror = null
  },
  async convertHEIC (fileURL) {
    let blobRes = await fetch(fileURL)
    let blob = await blobRes.blob()
    let conversionResult = await heic2any({ blob })
    const url = window.URL.createObjectURL(conversionResult)
    return url
  },
  isVideo (filename) {
    if (!filename || !filename.length) return false
    const parts = filename.split('.')
    const ext = parts?.[parts?.length - 1]
    switch (ext?.toLowerCase()) {
      case 'm4v':
      case 'avi':
      case 'mpg':
      case 'mp4':
      case 'mov':
      case 'webm':
        // etc
        return true
    }
    return false
  },
  formatImageBase64TiptapEditor (content) {
    if (!content) return ''

    const regex = /data:image\/[^;]+;base64[^"]+/
    const hasBase64Image = regex?.test(content)

    if (!hasBase64Image) return content

    let result = content.replace('src=\\', 'src=')

    if (!result.endsWith('" />')) {
      result += '" />'
    }
    return result
  },
  isUseLiveHodoV2 (useForType) {
    if (useForType === 'meet') return true
    return process.env.VUE_APP_100MS_MODE === 'true'
  },
  numberToWords (number) {
    const defaultNumbers = ' hai ba bốn năm sáu bảy tám chín'

    const chuHangDonVi = ('1 một' + defaultNumbers).split(' ')
    const chuHangChuc = ('lẻ mười' + defaultNumbers).split(' ')
    const chuHangTram = ('không một' + defaultNumbers).split(' ')

    const convert_block_three = number => {
      if (number === '000') return ''
      var _a = number + ''

      switch (_a.length) {
        case 0:
          return ''
        case 1:
          return chuHangDonVi[_a]
        case 2:
          return convert_block_two(_a)
        case 3:
          var chuc_dv = ''

          if (_a.slice(1, 3) !== '00') {
            chuc_dv = convert_block_two(_a.slice(1, 3))
          }
          var tram = chuHangTram[_a[0]] + ' trăm'
          return tram + ' ' + chuc_dv
      }
    }

    const convert_block_two = number => {
      var dv = chuHangDonVi[number[1]]
      var chuc = chuHangChuc[number[0]]
      var append = ''

      if (number[0] > 0 && number[1] === 5) {
        dv = 'lăm'
      }
      if (number[0] > 1) {
        append = ' mươi'
        if (number[1] === 1) {
          dv = ' mốt'
        }
      }

      return chuc + '' + append + ' ' + dv
    }

    const dvBlock = '1 nghìn triệu tỷ'.split(' ')

    var str = parseInt(number) + ''
    var i = 0
    var arr = []
    var index = str.length
    var result = []
    var rsString = ''

    // eslint-disable-next-line no-use-before-define
    if (index === 0 || str === 'NaN') {
      return ''
    }

    while (index >= 0) {
      arr.push(str.substring(index, Math.max(index - 3, 0)))
      index -= 3
    }
    for (i = arr.length - 1; i >= 0; i--) {
      if (arr[i] !== '' && arr[i] !== '000') {
        result.push(convert_block_three(arr[i]))
        if (dvBlock[i]) {
          result.push(dvBlock[i])
        }
      }
    }
    rsString = result.join(' ')

    return rsString.replace(/[0-9]/g, '').replace(/ /g, ' ').replace(/ $/, '') + ' đồng'
  },
  cleanObject (obj) {
    for (let key in obj) {
      if (!obj[key]) {
        delete obj[key]
      }
    }
    return obj
  },
  convertBase64tToFile (dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  },
  convertFileToBase64 (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
    })
  },
  deleteItemsFromObject (obj, keysToDelete) {
    keysToDelete.forEach(key => {
      delete obj[key]
    })
    return obj
  },
  formatDurationMoment (seconds, lang = 'vi', compact = false) {
    const locale = lang === 'jp' ? 'ja' : lang
    moment.locale(locale)
    const d = moment.duration(seconds, 'seconds')
    const h = Math.floor(d.asHours())
    const m = d.minutes()
    const s = d.seconds()

    const labels = {
      vi: { h: 'giờ', m: 'phút', s: 'giây', zero: '0 giây' },
      en: { h: 'hour', m: 'minute', s: 'second', zero: '0 seconds' },
      ja: { h: '時間', m: '分', s: '秒', zero: '0秒' },
      fr: { h: 'heure', m: 'minute', s: 'seconde', zero: '0 seconde' }
    }

    const L = labels[locale] || labels.vi
    const parts = []

    const pluralize = (num, word) => {
      if (locale === 'en' || locale === 'fr') return num > 1 ? word + 's' : word
      return word
    }

    const sep = locale === 'ja' ? '' : ' '

    if (h > 0) parts.push(`${h}${sep}${pluralize(h, L.h)}`)
    if (m > 0) parts.push(`${m}${sep}${pluralize(m, L.m)}`)
    if (s > 0) parts.push(`${s}${sep}${pluralize(s, L.s)}`)
    if (parts.length === 0) parts.push(L.zero)

    return compact && parts.length > 2 ? parts.slice(0, 2).join(sep) : parts.join(sep)
  },
  escapeHTML (str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  },
  stripMarkdownKeepHTML (input) {
    if (!input) return ''
    let output = input

    // Remove code blocks ```lang ... ```
    output = output.replace(/```(\w+)?([\s\S]*?)```/g, (match, lang, content) => {
      const language = lang ? lang.toLowerCase() : ''
      const code = content.trim()

      if (language === 'html') {
        return code
      } else if (['js', 'javascript', 'css', 'bash', 'sh', 'json'].includes(language)) {
        return `<pre><code class="language-${language}">${this.escapeHTML(code)}</code></pre>`
      }

      return ''
    })

    // Remove inline code markdown `code`
    output = output.replace(/`([^`]+)`/g, '$1')
    // Remove other markdown syntax
    output = output
      .replace(/!\[.*?\]\(.*?\)/g, '') // Image
      .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1') // Link
      .replace(/(\*\*|__)(.*?)\1/g, '$2') // Bold
      .replace(/(\*|_)(.*?)\1/g, '$2') // Italic
      .replace(/^#+\s?/gm, '') // Heading
      .replace(/^>\s?/gm, '') // Quote
      .replace(/^\s*[-*+]\s+/gm, '') // List
      .replace(/^\d+\.\s+/gm, '') // Numbered list

    output.trim()

    const html = marked.parse(output, { mangle: false, headerIds: false })
    return DOMPurify.sanitize(html)
  },
  cleanHtml (html) {
    return DOMPurify.sanitize(html || '', {
      ALLOWED_TAGS: ['p', 'strong', 'b', 'em', 'i', 'br', 'ul', 'ol', 'li', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div'],
      ALLOWED_ATTR: []
    })
  }
}

export default appUtils
